import { Pipe, PipeTransform } from '@angular/core';
import { ColumnTypeEnum } from '@y42/json-schema';
import { ColumnTypeToTypescriptTypeConverter } from '../helpers/column-to-typescript-type-converter';

@Pipe({
  name: 'columnTypeToTsType',
})
export class ColumnTypeToTsTypePipe implements PipeTransform {
  transform(value: string | ColumnTypeEnum): ReturnType<typeof ColumnTypeToTypescriptTypeConverter> {
    return ColumnTypeToTypescriptTypeConverter(value as ColumnTypeEnum);
  }
}
